/**
 * Create an image element and only return the reference when the image successfully loads
 * @param src
 * @returns
 */
export async function loadImage(src: string) {
  const img = document.createElement('img');
  img.src = src;
  return new Promise<HTMLImageElement>((res, rej) => {
    img.addEventListener('load', () => res(img));
    img.addEventListener('error', () => rej());
  });
}
